import React from "react";

/** up/down trend arrow, coloured green/red */
export const TrendArrow = ({ up }: { up: boolean }) => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={up ? "#027A48" : "#B42318"} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <path d={up ? "M6 15l6-6 6 6" : "M6 9l6 6 6-6"} />
  </svg>
);

/** white check used inside filled checkboxes */
export const CheckMark = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

/** filled star (uses current colour) — symmetric 5-point star */
export const StarIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" stroke="none">
    <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27Z" />
  </svg>
);

export const ChevronDown = ({
  size = 12,
  color = "currentColor",
}: {
  size?: number;
  color?: string;
}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 9l6 6 6-6" />
  </svg>
);

type KpiName =
  | "campus"
  | "students"
  | "class"
  | "book"
  | "pages"
  | "teacher"
  | "quiz"
  | "time";

const KPI_PATHS: Record<KpiName, string[]> = {
  campus: ["M3 21h18", "M5 21V8l7-4 7 4v13", "M9 21v-5h6v5"],
  students: ["M12 3 2 8l10 5 10-5-10-5z", "M6 10.5V15c0 1.4 2.7 2.5 6 2.5s6-1.1 6-2.5v-4.5"],
  class: ["M3 5h8v14H3z", "M13 5h8v14h-8z", "M6 9h2M6 12h2M16 9h2M16 12h2"],
  book: ["M5 4a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v16l-6.5-3.2L5 20z"],
  pages: ["M14 3v4a1 1 0 0 0 1 1h4", "M5 3h9l5 5v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z", "M9 13h6M9 17h4"],
  teacher: ["M22 10 12 5 2 10l10 5 10-5z", "M6 12v5c0 1 2.7 2.5 6 2.5s6-1.5 6-2.5v-5", "M22 10v6"],
  time: ["M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z", "M12 7v5l3.5 2"],
  quiz: ["M15 3H9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z", "M8 4H6a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2", "M9 14l2 2 4-4"],
};

export const KpiIcon = ({ name }: { name: KpiName }) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    {(KPI_PATHS[name] || []).map((d, i) => (
      <path key={i} d={d} />
    ))}
  </svg>
);
